import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

export function downloadExcel(data, config = {}) {
  if (!Array.isArray(data) || data.length === 0) {
    toast?.error?.('No data available to export');
    return;
  }

  const { fileName = 'export.xlsx', sheetName = 'Sheet1', columns } = config;

  // If no columns config, fallback to raw data keys
  const defaultKeys = Object.keys(data[0]);
  const keys = columns ? Object.keys(columns) : defaultKeys;
  const headers = columns || Object.fromEntries(defaultKeys.map(k => [k, k]));

  const formattedData = data.map(row => {
    const newRow = {};
    keys.forEach(key => {
      newRow[headers[key]] = row[key];
    });
    return newRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, fileName);
}

export function downloadBonusExcel(sheets, config = {}) {
  // Validate sheets data
  if (!Array.isArray(sheets) || sheets.length === 0) {
    toast?.error?.('No sheets data available to export');
    return;
  }

  const { fileName = 'export.xlsx' } = config;
  const workbook = XLSX.utils.book_new();

  // Process each sheet
  sheets.forEach(sheet => {
    const {
      data,
      sheetName = 'Sheet1',
      columns, // key: label (maintains order)
    } = sheet;

    if (!Array.isArray(data) || data.length === 0) {
      toast?.warn?.(`No data available for sheet: ${sheetName}`);
      return;
    }

    // If no columns config, fallback to raw data keys
    const defaultKeys = Object.keys(data[0]);
    const keys = columns ? Object.keys(columns) : defaultKeys;
    const headers = columns || Object.fromEntries(defaultKeys.map(k => [k, k]));

    const formattedData = data.map(row => {
      const newRow = {};
      keys.forEach(key => {
        newRow[headers[key]] = row[key];
      });
      return newRow;
    });

    // Create worksheet and append to workbook
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  // Save workbook
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, fileName);
}
